export default __webpack_public_path__ + "static/media/teams.b45cb600.svg";